import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {MappingOrderReferencePatternService} from "../../../services/mapping/mapping-order-reference-pattern.service";
import {OrderReferencePattern} from "../../../model/mapping/order-reference-pattern";
import {ClearingHouse} from "../../../model/exchange/clearing-house";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-order-ref-patt',
  templateUrl: './order-reference-pattern.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class OrderReferencePatternComponent extends CrudBaseComponent<OrderReferencePattern> {

  //fields
  owners: FieldRecord<any>[]
  clearingHouses: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              crudService: MappingOrderReferencePatternService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = crudService;
    this.newRecord = new OrderReferencePattern();
    this.newRecord.clearingHouseCode = ClearingHouse.ALL_TEXT;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.owner = undefined;
      this.formRecord.clearingHouseCode = ClearingHouse.ALL_TEXT;
      this.formRecord.originOwner = undefined;
      this.formRecord.originClearingHouseCode = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'owner',
        width: 130
      },
      {
        field: 'clearingHouseCode',
        width: 130
      },
      {
        field: 'pattern',
        width: 130
      },
      {
        field: 'validationRegex',
        width: 130
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'owner',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.owners,
            optionValue: 'text'
          },
          {
            field: 'clearingHouseCode',
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.clearingHouses,
          },
          {
            field: 'pattern',
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'validationRegex',
            required: true,
            column: 6,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.commonFieldService.getOwners(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.owners = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.clearingHouses = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      let defaultAllExchange = FieldRecord.DEFAULT();
      defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
      defaultAllExchange.id = ClearingHouse.ALL_TEXT;
      this.clearingHouses.unshift(defaultAllExchange);
      this.settingsFormLoadingProgressValue += 100 / 2;
    });
  }

  onFormShow() {
  }
}
